<script>
import { GlButton, GlSkeletonLoader } from '@gitlab/ui';
import { n__, s__ } from '~/locale';
import AiWidgetSegment from '../ai_widget/ai_widget_segment.vue';

export default {
  name: 'DecisionLogInlineRow',
  components: {
    AiWidgetSegment,
    GlButton,
    GlSkeletonLoader,
  },
  props: {
    count: {
      type: Number,
      required: false,
      default: 0,
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    isPanelOpen: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['open', 'close'],
  computed: {
    statusText() {
      if (!this.count) return s__('WorkItemDecisionLog|No decisions yet');

      return n__('%d entry', '%d entries', this.count);
    },
  },
  methods: {
    onClick() {
      this.$emit(this.isPanelOpen ? 'close' : 'open');
    },
  },
};
</script>

<template>
  <ai-widget-segment
    :label="s__('WorkItemDecisionLog|Decision log')"
    data-testid="decision-log-inline-row"
  >
    <gl-skeleton-loader
      v-if="isLoading"
      :width="80"
      :height="16"
      data-testid="decision-log-loading"
    >
      <rect width="80" height="16" rx="4" />
    </gl-skeleton-loader>

    <!-- The count opens the panel once there is something to read in it. With no decisions the
      panel has only its empty state, so the row stays plain text. -->
    <gl-button
      v-else-if="count"
      variant="link"
      class="gl-w-fit !gl-text-sm"
      :aria-label="s__('WorkItemDecisionLog|View decision log')"
      :aria-pressed="String(isPanelOpen)"
      data-testid="open-decision-log-button"
      @click="onClick"
    >
      {{ statusText }}
    </gl-button>
    <span v-else class="gl-text-subtle" data-testid="decision-log-status">
      {{ statusText }}
    </span>
  </ai-widget-segment>
</template>
